import {GET_WEEK} from '../Actions/types'

const initialState= { 
    hoursInDay: null,

}

export default function (state = initialState, action) {

        switch(action.type) {
            case GET_WEEK: 
                return{
                    ...state,
                    lastWeekOfData: action.payload
                };
                default: 
            return state;

        }
    }



// WEBPACK FOOTER //
// ./src/Reducers/WeekChartReducer.js